/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Sidebar, Menu, MenuItem, menuClasses } from 'react-pro-sidebar';
import Images from '../../assets/images';
import { Link, useNavigate, useLocation } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import CustomMenuItem from "./MenuItem";
import { useAuthenticator, withAuthenticator } from '@aws-amplify/ui-react';
import { getUserInfo } from '../../utils/helpers/getUserInfo';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useQuery } from '@tanstack/react-query';
import { API } from 'aws-amplify';

const iconFilter = { filter: 'brightness(0) invert(1)', width: '24px', height: '24px' };

const DashboardFlyoutWrapper = ({ data, selectedRoute, setSelectedRoute, sidebarOpen, navigate }) => {
  const [showFlyout, setShowFlyout] = React.useState(false);

  return (
    <div
      style={{ position: 'relative' }}
      onMouseEnter={() => setShowFlyout(true)}
      onMouseLeave={() => setShowFlyout(false)}
    >
      <MenuItem
        active={selectedRoute === '/dashboard-analytics' || selectedRoute.startsWith('/dashboard')}
        onClick={() => {
          setSelectedRoute('/dashboard-analytics');
          navigate('/dashboard-analytics');
        }}
        icon={
          <img
            src={Images.IconChartLine}
            alt="Dashboard Analytics"
            style={iconFilter}
          />
        }
        suffix={
          sidebarOpen && data && data.length > 0 ? (
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L6 6L1 11" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          ) : null
        }
        component={<Link to="/dashboard-analytics" className="link" />}
      >
        Dashboard Analytics
      </MenuItem>
      {showFlyout && data && data.length > 0 && (
        <div
          style={{
            position: 'absolute',
            left: '100%',
            top: '0',
            paddingLeft: '8px',
            zIndex: 100,
          }}
        >
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '10px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.12)',
            padding: '12px 0',
            minWidth: '260px',
            position: 'relative',
          }}
        >
          {/* Triangle pointer */}
          <div
            style={{
              position: 'absolute',
              left: '-8px',
              top: '16px',
              width: 0,
              height: 0,
              borderTop: '8px solid transparent',
              borderBottom: '8px solid transparent',
              borderRight: '8px solid #ffffff',
              filter: 'drop-shadow(-3px 0px 2px rgba(0, 0, 0, 0.06))',
            }}
          />
          {data.map((route, index) => (
            <div
              key={index}
              onClick={() => {
                setSelectedRoute(`/${route.id}`);
                navigate(`/${route.id}`);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 16px',
                cursor: 'pointer',
                transition: 'background-color 0.15s ease',
                backgroundColor: selectedRoute === `/${route.id}` ? '#f0f7ff' : 'transparent',
              }}
              onMouseEnter={(e) => { if (selectedRoute !== `/${route.id}`) e.currentTarget.style.backgroundColor = '#f5f5f5'; }}
              onMouseLeave={(e) => { if (selectedRoute !== `/${route.id}`) e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              <img
                src={Images.SideBarDashboardItem}
                alt={route.name}
                style={{
                  width: '24px',
                  height: '24px',
                  marginRight: '12px',
                  filter: 'brightness(0) saturate(100%) invert(72%) sepia(30%) saturate(500%) hue-rotate(165deg) brightness(100%) contrast(85%)',
                }}
              />
              <span style={{
                fontFamily: 'Poppins',
                fontSize: '14px',
                fontWeight: 500,
                color: '#003087',
              }}>
                {route.name}
              </span>
            </div>
          ))}
        </div>
        </div>
      )}
    </div>
  );
};

const SideBar = ({ isOpen, toggle, selectedRoute, setSelectedRoute, setIsOpen }) => {
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { token } = getUserInfo(user);
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    setSelectedRoute(location.pathname);
  }, [location.pathname]);

  const handleClose = () => {
    setShow(false);
    setIsOpen(false);
  };
  const handleShow = () => setShow(true);

  const removeDuplicates = (arr, key) => {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }

  const { data } = useQuery({
    queryKey: ['getConfigClientData', user, 'dashboard'],
    queryFn: async () => {
      const apiName = 'Routific_API';
      const path = `/get-config-client-data?email=${user.username}&type=dashboard`;
      const params = {
        headers: {
          Authorization: token,
        },
      };
      const res = await API.get(apiName, path, params);
      if (!res.length) return [];
      const newArr = [];
      res?.map((config) => {
        const parseValue = config.value ? JSON.parse(config.value) : [];
        newArr.push(...parseValue);
        return parseValue;
      });
      localStorage.setItem('DASHBOARD_LIST_ITEM', JSON.stringify(newArr));
      return newArr.length ? removeDuplicates(newArr, "id") : [];
    },
    enabled: !!user,
  });

  const onSignOut = async () => {
    try {
      await signOut();
      setSelectedRoute('/');
      navigate('/', { replace: true });
    } catch (err) {
      console.log(err);
    }
  };

  const menuItemStyles = {
    root: {
      color: '#ffffff',
      fontFamily: 'Poppins',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      [`&.${menuClasses.collapsed}`]: {
        width: '65px',
        minWidth: '65px',
      }
    },
    icon: {
      margin: '0 5px 0 0',
      color: '#ffffff',
      [`&.${menuClasses.disabled}`]: {
        color: '#5a7a99',
      },
    },
    button: ({ level }) => {
      let buttonStyles = {
        margin: '8px',
        borderRadius: '6px',
        height: '48px',
      }
      if (level === 0) {
        buttonStyles = {
          ...buttonStyles,
          paddingLeft: '4px',
          paddingRight: '12px',
          fontWeight: '600',
        }
      }
      if (level === 1) {
        buttonStyles = {
          ...buttonStyles,
        }
      }
      return {
        ...buttonStyles,
        [`&.${menuClasses.disabled}`]: {
          color: '#5a7a99',
        },
        '&:hover': {
          backgroundColor: 'transparent',
          color: '#7EC8E3',
        },
        '&:active': {
          backgroundColor: 'transparent',
          color: '#7EC8E3',
        },
        [`&.${menuClasses.active}`]: {
          backgroundColor: '#004488',
          color: '#ffffff',
        }
      }
    },
    label: ({ open }) => ({
      fontWeight: open ? 600 : undefined,
    }),
  };

  return (
    <Sidebar
      collapsed={!isOpen}
      breakPoint="md"
      rootStyles={{
        color: '#ffffff',
        background: '#003087',
        boxShadow: '4px 0 10px rgba(0, 0, 0, 0.12)',
        borderRight: 'none',
        width: '325px',
        zIndex: '9',
        overflow: 'visible',
      }}
    >
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        background: '#003087',
        position: 'relative',
      }}>
        <div
          className="sidebar-toggle-tab"
          onClick={toggle}
          style={{
            position: 'absolute',
            top: '0',
            right: '-22px',
            width: '22px',
            height: '120px',
            backgroundColor: '#6EC1E4',
            borderRadius: '0 6px 6px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            zIndex: 10,
            boxShadow: '3px 2px 6px rgba(0, 0, 0, 0.15)',
            transition: 'background-color 0.2s ease',
          }}
        >
          <svg
            width="8"
            height="14"
            viewBox="0 0 8 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              transition: 'transform 0.3s ease',
              transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
            }}
          >
            <path d="M7 1L1 7L7 13" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div style={{ height: '16px' }} />
        <div style={{ flex: 1, marginBottom: '32px' }}>
          <Menu menuItemStyles={menuItemStyles} closeOnClick>
            {isOpen ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0px 8px',
                  margin: '8px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(126, 200, 227, 0.2)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                onClick={() => {
                  setSelectedRoute('/');
                  navigate('/');
                }}
              >
                <img
                  src={Images.WhiteLogo}
                  alt="Home"
                  style={{ maxHeight: '120px', objectFit: 'contain' }}
                />
              </div>
            ) : (
              <MenuItem
                active={selectedRoute === '/'}
                onClick={() => {
                  setSelectedRoute('/')
                }}
                icon={
                  <img
                    src={Images.IconGPLS}
                    alt="Home"
                    style={iconFilter}
                  />
                }
                component={<Link to="/" className="link" />}
              >
              </MenuItem>
            )}
            <MenuItem
              active={selectedRoute === '/transport'}
              onClick={() => {
                setSelectedRoute('/transport')
              }}
              icon={
                <img
                  src={Images.IconRoute}
                  alt="Transport & Logistics"
                  style={iconFilter}
                />
              }
              component={<Link to="/transport" className="link" />}
            >
              Transport & Logistics
            </MenuItem>
            {/* Flyout commented out for now - uncomment to enable hover popup on Dashboard Analytics
            <DashboardFlyoutWrapper
              data={data}
              selectedRoute={selectedRoute}
              setSelectedRoute={setSelectedRoute}
              sidebarOpen={isOpen}
              navigate={navigate}
            />
            */}
            <MenuItem
              active={selectedRoute === '/dashboard-analytics' || data?.some((d) => `/${d.id}` === selectedRoute)}
              onClick={() => {
                setSelectedRoute('/dashboard-analytics');
              }}
              icon={
                <img
                  src={Images.IconChartLine}
                  alt="Dashboard Analytics"
                  style={iconFilter}
                />
              }
              component={<Link to="/dashboard-analytics" className="link" />}
            >
              Dashboard Analytics
            </MenuItem>
            <MenuItem
              active={selectedRoute === '/imaging'}
              onClick={() => {
                setSelectedRoute('/imaging')
              }}
              icon={
                <img
                  src={Images.IconXray}
                  alt="Diagnostic Imaging"
                  style={iconFilter}
                />
              }
              component={<Link to="/imaging" className="link" />}
              rootStyles={{ opacity: 0.5 }}
            >
              Diagnostic Imaging
            </MenuItem>
            <MenuItem
              active={selectedRoute === '/cost-per-test'}
              onClick={() => {
                setSelectedRoute('/cost-per-test')
              }}
              icon={
                <img
                  src={Images.IconCost}
                  alt="Cost Per Test"
                  style={iconFilter}
                />
              }
              component={<Link to="/cost-per-test" className="link" />}
              rootStyles={{ opacity: 0.5 }}
            >
              Cost Per Test
            </MenuItem>
          </Menu>
        </div>
        <div
          onClick={handleShow}
          style={{
            padding: '12px',
            display: 'flex',
            alignItems: 'center',
            height: '50px',
            cursor: 'pointer',
            marginBottom: '5px'
          }}
        >
          <img src={Images.SideBarSignout} alt="sign out" style={{ marginRight: '5px', paddingLeft: '4px', ...iconFilter }} />
          {
            isOpen ? (
              <span style={{ fontWeight: '600', fontSize: '14px', color: '#ffffff' }}>Sign out</span>
            ) : null
          }
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="sm"
        style={{
          marginTop: '60px'
        }}
      >
        <Modal.Body>
          <Modal.Title
            className="text-center"
            style={{ fontSize: '16px', color: '#667085' }}
          >Sign out</Modal.Title>
        </Modal.Body>
        <Modal.Footer className="d-flex align-items-center justify-content-center" style={{ borderTop: 'none' }}>
          <Button size="sm" variant="light" onClick={handleClose} style={{
            color: '#4C697F',
            background: '#fff',
            border: '1px solid #4C697F'
          }}>
            Cancel
          </Button>
          <Button size="sm" variant="secondary" onClick={onSignOut} style={{
            color: '#fff',
            background: '#4C697F',
          }}>Confirm</Button>
        </Modal.Footer>
      </Modal>
    </Sidebar>
  )
}

export default withAuthenticator(SideBar, {
  hideSignUp: true
});
